import { unix } from "moment";

export default function formatDateFromUnix(unixDate: number | undefined, format: string) {
    return unix(unixDate || 0).format(format);
}
